module.exports = __webpack_public_path__ + "static/media/logo.a3b808f4.svg";